(function (){
    'use strict';

    angular
        .module('services')
        .service('CitiesByExpoService', CitiesByExpoService);

    CitiesByExpoService.$inject = ['$http', 'API_BASE'];

    function CitiesByExpoService ($http, API_BASE) {
        var service = this;

        service.getCities = getCities;
        service.getCitiesByExposIds = getCitiesByExposIds;


        function getCities (expo_id) {
            return $http.get(API_BASE + '/expos/'+expo_id+'/cities/list',{header : {'Content-Type':'application/json; charset=UTF-8'}});
        }

        function getCitiesByExposIds(data)
        {
            return $http.get(API_BASE + '/expos/citiesbyexposids',{params:data});
        }

    }
})();